import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TKhattabatConversations } from "../../Types";
import { post } from "../axios-post";
import getKhattabatStore from "../../stores/khattabat-stores";
import getKhattabat101CStore from "../../stores/khattabat-stores/101c-stores";

export const apiCallGetConversations = async (
  userID: number
): Promise<{
  data: TKhattabatConversations;
  status: string;
  code: Ti18nKeys;
}> => {
  const alKhattabaUUID = getKhattabatStore().alkhattabaUUID.get();
  const { userUUID, oneOOneCId } = getKhattabat101CStore(userID);
  const { status, data, et3Error } = await post<TKhattabatConversations>(
    `khattabat/getAlkhattabatConverstions`,
    {
      alKhattabaUUID,
      userUUID: userUUID.get(),
      oneOOneCId: oneOOneCId.get()
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        oneOOneCMessages: [],
        oneOOneCComments: [],
        oneOTwoMessages: {},
        alKhattabaUUID: "",
        userUUID: "",
        userID: -1,
        oneOOneCId: ""
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        oneOOneCMessages: [],
        oneOOneCComments: [],
        oneOTwoMessages: {},
        alKhattabaUUID: "",
        userUUID: "",
        userID: -1,
        oneOOneCId: ""
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
